var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loader"},[(_vm.progress != 1)?_c('div',{staticClass:"progress",style:({width: (((_vm.progress * 10 )/ _vm.timer) + "%")})}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }